/**
 * Paths that share the meeting filter store (list search, sort, filters).
 * Keep in sync with route reset rules and meeting UI (SearchFilter, MeetingLayout).
 */
export function isMeetingModulePath(path: string): boolean {
	if (path.startsWith('/meetings')) return true;
	if (path === '/meeting' || path.startsWith('/meeting/')) return true;
	if (path.startsWith('/meeting-details')) return true;
	if (path.startsWith('/today-meetings')) return true;
	if (path.startsWith('/complete-meeting')) return true;
	return false;
}
